import { FormlyFieldConfig } from '@ngx-formly/core';

export const placeholderInputForm: FormlyFieldConfig[] = [
  {
    wrappers: ['row'],
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        wrappers: ['row'],
        className: 'form-wrapper--row',
        fieldGroup: [
          {
            key: 'props.placeholder',
            type: 'input',
            props: {
              translate: true,
              label: 'formGenerator.uiElement.placeholderProp.label',
            },
          },
        ],
      },
    ],
  },
];
